import { useTranslation } from "react-i18next";
import React, { ChangeEvent, FunctionComponent, KeyboardEvent, useState } from 'react';
import { Button, Dropdown, Input, MenuProps, message, Modal, Progress, Space, Typography, Upload, UploadProps } from 'antd';
import { DownOutlined, LoadingOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons";
import FormInput from '../../../../../components/form-input/FormInput';
import './filter-table.scss';
import { BASE_URL_V2 } from '../../../../../config/api/configApiv2';
import { useAuthStore } from '../../../../../stores/stores';

type FilterTableProps = {
  tab: string,
  searchValue: string,
  isEmptyWard: boolean,
  isRendering: boolean,
  isEmptyDistrict: boolean,
  handleOpen: () => void,
  exportExcel: () => void,
  handleOpenFilter: () => void,
  handleDownloadFile: () => void,
  handleSubmitSearch: () => void,
  importExcel: (file: any) => void,
  handleSearch: (e: KeyboardEvent<HTMLSpanElement>) => void,
  handleChangeInput: (e: ChangeEvent<HTMLInputElement>) => void,
}

const FilterTable: FunctionComponent<FilterTableProps> = ({
  tab,
  searchValue,
  isRendering,
  isEmptyWard,
  isEmptyDistrict,
  handleOpen,
  exportExcel,
  importExcel,
  handleSearch,
  handleOpenFilter,
  handleChangeInput,
  handleSubmitSearch,
  handleDownloadFile,
}) => {
  const { t } = useTranslation();
  const [fileName, setFileName] = useState<string>("");
  const [progress, setProgress] = useState<number>(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showProgress, setShowProgress] = useState<boolean>(false);
  const [isUploading, setIsUploading] = useState<boolean>(true);
  const [file, setFile] = useState<any>();
  const accessToken = useAuthStore((state) => state.accessToken);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleImportExcel = () => {
    const formData = new FormData();
    formData.append('file', file);
    importExcel(formData);
    setIsModalOpen(false);
    setFileName("");
    setShowProgress(false);
    setIsUploading(true);
  }

  const handleOk = () => {
    Modal.confirm({
      title: t("Xác nhận tải dữ liệu", "Xác nhận tải dữ liệu"),
      content: ``,
      onOk: () => handleImportExcel(),
      centered: true,
      okText: t("Xác nhận", "Xác nhận"),
      cancelText: t("Huỷ bỏ", "Huỷ bỏ"),
      footer: (_, { OkBtn, CancelBtn }) => (
        <>
          <CancelBtn />
          <OkBtn />
        </>
      ),
    });
  };
  
  const handleCancel = () => {
    setFileName("");
    setIsUploading(true);
    setShowProgress(false);
    setIsModalOpen(false);
  };

  const items: MenuProps['items'] = [
    {
      label: t("Tạo mới", "Tạo mới"),
      key: '1',
      onClick: handleOpen,
    },
    {
      label: t("Import dữ liệu", "Import dữ liệu"),
      key: '2',
      onClick: showModal,
    },
    {
      label: t("Tải file mẫu", "Tải file mẫu"),
      key: '3',
      onClick: handleDownloadFile,
    },
  ];

  const menuProps = {
    items,
  };

  const props: UploadProps = {
    name: 'file',
    action: BASE_URL_V2 + `/mooc-course-block-quiz/upload-file`,
    headers: {
      Authorization: "Bearer " + accessToken,
    },
    beforeUpload: (file) => {
      if (!isCorrectFile(file)) {
        message.error(t("Bạn phải tải lên file excel !", "Bạn phải tải lên file excel !"));
        return Upload.LIST_IGNORE;
      }
    },
    onChange(info) {
      setProgress(0);
      setFileName(info.file.name);
      setShowProgress(true);
      setIsUploading(true);
      if (info.file.status === "uploading") {

      }
      if (info.file.status === "done") {
        setFile(info.file.originFileObj);
        setProgress(Math.round(100));
        setIsUploading(false);
      }
    },
  };

  const isCorrectFile = (file: any) => {
    const acceptFile = [
      // excel
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    const isJpgOrPng = acceptFile.includes(file.type);
    // const isCorrectFile = file.size < MAX_FILE_UPLOAD_SIZE;
    if (isJpgOrPng) {
      return true;
    }
    return false;
  };
  
  const renderText = () => {
    switch (tab) {
      case "1":
        return t("cấp Tỉnh", "cấp Tỉnh");
      case "2":
        return t("cấp Huyện", "cấp Huyện");
      case "3":
        return t("cấp Xã", "cấp Xã");
      default:
        return t("Không xác định", "Không xác định");
    }
  };

  const handleExportExcel = () => {
    Modal.confirm({
      title: `${t("Xác nhận kết xuất danh sách đơn vị hành chính", "Xác nhận kết xuất danh sách đơn vị hành chính")} ${renderText()}`,
      content: ``,
      onOk: () => exportExcel(),
      centered: true,
      okText: t("Xác nhận", "Xác nhận"),
      cancelText: t("Huỷ bỏ", "Huỷ bỏ"),
      footer: (_, { OkBtn, CancelBtn }) => (
        <>
          <CancelBtn />
          <OkBtn />
        </>
       ),
    });
  }

  return (
    <>
      <div className="filter-table-administrative-unit">
        <div className="heading-item heading-filter">
          <Button className="filter-button" onClick={handleOpenFilter}>
            <Typography.Text> {t('Bộ lọc', 'Bộ lọc')} </Typography.Text>
            <DownOutlined />
          </Button>
        </div>
        <div className="heading-item heading-search">
          <FormInput placeholder={t("Nhập tên để tìm kiếm", "Nhập tên để tìm kiếm")} value={searchValue}
            onChange={handleChangeInput} onKeyPress={handleSearch}
            afterPrefixIcon={<SearchOutlined onClick={handleSubmitSearch} />} />
        </div>
        <div className="heading-item heading-resigter">
          <Button className="btn btn-primary" onClick={handleExportExcel} disabled={isRendering || (tab === "2" && isEmptyDistrict) || (tab === "3" && isEmptyWard)}>
            <Typography.Text>{isRendering ? <LoadingOutlined /> : ''} {t("Kết xuất", "Kết xuất")} </Typography.Text>
          </Button>
        </div>
        <div className="heading-item heading-resigter">
          <Dropdown menu={menuProps}>
            <Button className='btn-add-new'>
              <Space> {t('Thêm mới', 'Thêm mới')} <DownOutlined /> </Space>
            </Button>
          </Dropdown>
        </div>
      </div>
      <Modal className="administrative-unit-import-modal" title={`${t("Import đơn vị hành chính", "Import đơn vị hành chính")} ${renderText()}`} open={isModalOpen} onOk={handleOk}
        onCancel={handleCancel} okText={t("Tải lên", "Tải lên")} okButtonProps={{ disabled: isUploading }} cancelText={t("Hủy", "Hủy")}>
        <Space.Compact>
          <Input className="name-label" placeholder={t("Chọn file từ máy tính", "Chọn file từ máy tính")} value={fileName} readOnly />
          <Upload showUploadList={false} {...props} maxCount={1}>
            <Button className="btn-primary">{t("Chọn tệp", "Chọn tệp")}</Button>
          </Upload>
        </Space.Compact>
        <div className={`upload-progress ${showProgress ? "progress-on" : "progress-off"}`}>
          <Typography.Text className="progress-label">
            {progress !== 100 ? t('Đang tải lên', 'Đang tải lên') : t('Đã tải lên', 'Đã tải lên')}({progress}%)
          </Typography.Text>
          <Progress percent={progress} showInfo={false} />
        </div>
      </Modal>
    </>
  );
};

export default FilterTable;
